// extracted by mini-css-extract-plugin
export default {"header":"styles_header__ySkAH","actions":"styles_actions__hqORc"};